import VueI18n from 'vue-i18n';
import zh_CN from '../static/lib/i18n/zh-CN.js'
import zy_CN from '../static/lib/i18n/zy-CN.js'

// Vue.use(VueI18n);
// // 创建vue-i18n实例i18n
// const i18n = new VueI18n({
//     // 设置默认语言
//     locale: localStorage.getItem('locale') || 'zh',  // 语言标识
//     // 添加多语言（每一个语言标示对应一个语言文件）
//     messages: {
//         'en': require('i18/strings-en.json'),
//         'zh': require('i18/strings-zn.json')
//     }
// });
// // 暴露i18n
// export default i18n;
((global,factory) => {
    global.i18n = factory;
    factory(global);
  })(window || this,() => {
    Vue.use(VueI18n);
    var lang = navigator.language.toLocaleLowerCase()
    // var lang = 'zy'
    var menus = {
      'zh-cn': 'zh',
      'en-us': 'zh',
      'zh-zy': 'zy'
    }
    var langStore = menus[lang] || lang
    // 创建vue-i18n实例i18n
    i18n = new VueI18n({
        // 设置默认语言
        locale: localStorage.getItem('locale') || langStore || 'zh',  // 语言标识
        // locale: 'zy',
        // 添加多语言（每一个语言标示对应一个语言文件）
        // messages: {
        //     'en': require('i18/strings-en.json'),
        //     'zh': require('i18/strings-zn.json')
        // }
        messages: {
            'zh': zh_CN,
            'zy': zy_CN
        }
    })
  })
 Vue.mixin({
   i18n
 })
 Vue.config.optionMergeStrategies.i18n =  Vue.config.optionMergeStrategies.el
